<div class="mct-flex mct-row mct-gap-27"  >
  <div   class="mr-30 mct-flex mct-col post-tx-30-gt-lg">
    <div *ngIf="!displayWarning">
      <p>{{ 'revenue.post-transactions.instruction' | translate | ucfirst }}:</p>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"   >
        <div>
          <wl-date-selector name="startDate" [(ngModel)]="searchParams.StartDate"></wl-date-selector>
        </div>
        <div>
          {{ 'common.to' | translate | ucfirst }}
        </div>
        <div>
          <wl-date-selector name="endDate" [(ngModel)]="searchParams.EndDate"></wl-date-selector>
        </div>
      </div>
      <div   class="mt-10 mb-40 mct-flex mct-row mct-gap-10">
        <p>OR</p>
        <div>
          <p-checkbox [(ngModel)]="searchParams.ShowUnpostedTransaction" binary="true"></p-checkbox>
          <label> {{ 'revenue.post-transactions.post-transactions-search.showUnpostedTransactions' | translate | titlecase }}</label>
        </div>
      </div>
    </div>
    <div class="mct-flex mct-row mct-gap-8 mct-gap-27-gt-lg"   >
      <div class="mct-flex mct-col" style="min-width: 220px;">
        <label
          ><p>{{ 'revenue.post-transactions.post-transactions-search.chooseAccountingPackage' | translate | titlecase }}</p>
          <p-select
            [options]="accountingPackages"
            [(ngModel)]="searchParams.AccountingPackageID"
            appendTo="body"
            placeholder="{{ 'revenue.post-transactions.post-transactions-search.accountingPackage' | translate | titlecase }}"
            [style]="{ width: '100%' }"
            (ngModelChange)="accountingPackageChanged()"
            (onChange)="invalidAccountingPackageSelected()"
          ></p-select>
        </label>
      </div>
      <div class="mct-flex mct-col" style="width: 180px;" *ngIf="!displayWarning">
        <label
          ><p>{{ 'revenue.post-transactions.post-transactions-search.chooseTransactionType' | translate | titlecase }}</p>
          <p-select
            [options]="transactionTypes"
            [(ngModel)]="searchParams.TranType"
            appendTo="body"
            showClear
            placeholder="{{ 'common.all' | translate | titlecase }}"
            [style]="{ width: '100%' }"
          ></p-select>
        </label>
      </div>
    </div>
  </div>
  <div class="mct-flex mct-col post-tx-0-1-40"   *ngIf="!displayWarning">
    <div class="mct-flex mct-row" >
      <label class="mb-13 mr-2">
        {{ 'revenue.post-transactions.post-transactions-search.transaction-codes' | translate | titlecase }}
      </label>
      <img
        src="/assets/img/info.png"
        title="{{ 'revenue.post-transactions.post-transactions-search.transaction-codes-info' | translate }}"
        class="wc-help-icon"
      />
    </div>
    <div class="transaction-codes-container atlas-autocomplete">
      <p-autocomplete
        [(ngModel)]="searchParams.TranCodes"
        [inputStyle]="{ width: '100%' }"
        [style]="{ width: '100%' }"
        [suggestions]="tranCodeSearchResult"
        [multiple]="true"
      [forceSelection]="true"
      (completeMethod)="searchTranCodes($event)"
      showEmptyMessage="true"
      [emptyMessage]="'revenue.post-transactions.post-transactions-search.tran-code-search-error' | translate | ucfirst"
      appendTo="body"
    >
    </p-autocomplete>
    </div>
  </div>
</div>
<div class="mct-flex mct-row" *ngIf="displayWarning" >
  <div class="mct-flex mct-col post-tx-0-1-40"  >
    <p>
      {{
        'revenue.post-transactions.post-transactions-search.warning-part-1'
          | translate : { selectedPackageTypeName: selectedPackageTypeName }
      }}
      <b>{{ 'revenue.post-transactions.post-transactions-search.warning-part-2' | translate }}</b>
    </p>

    <p>
      {{
        'revenue.post-transactions.post-transactions-search.warning-part-3'
          | translate : { selectedPackageTypeName: selectedPackageTypeName }
      }}
    </p>

    <ol>
      <li>
        {{ 'revenue.post-transactions.post-transactions-search.warning-part-4' | translate }}
      </li>
      <li>
        {{
          'revenue.post-transactions.post-transactions-search.warning-part-5'
            | translate : { selectedAccountingPackageName: selectedAccountingPackageName }
        }}
      </li>
      <li>
        {{
          'revenue.post-transactions.post-transactions-search.warning-part-6'
            | translate : { selectedPackageTypeName: selectedPackageTypeName }
        }}
      </li>
    </ol>
  </div>
</div>
